import {
  FaBullhorn,
  FaProjectDiagram,
  FaSearch,
  FaUserLock,
  FaCookieBite,
} from "react-icons/fa";
import {
  MdOutlineSecurity,
  MdOutlinePrivacyTip,
  MdOutlineLocalActivity,
  MdOutlineIndeterminateCheckBox,
  MdOutlineDiversity2,
  MdOutlineSubtitles,
} from "react-icons/md";
import { GoProjectRoadmap, GoLaw } from "react-icons/go";
import { BsFillTerminalFill } from "react-icons/bs";
import { SiManageiq, SiSpringsecurity } from "react-icons/si";
import { LiaBity } from "react-icons/lia";
import { AiFillControl } from "react-icons/ai";
import { TbAlignBoxRightStretch, TbListDetails } from "react-icons/tb";
import { VscLaw } from "react-icons/vsc";
import { PiMicroscopeFill } from "react-icons/pi";
import { IoNotifications } from "react-icons/io5";
import { BiLogoBlogger } from "react-icons/bi";
import { LuInspect } from "react-icons/lu";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import card2Bg from "../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../assets/Exactness/Header/Bg.svg";

export const legalContent = {
  privacy: {
    title1: "Your",
    titleline: "Privacy",
    title2: "Matters to Us",
    pretitle1: "Read Our Full",
    pretitle2: "Policy",
    pretitleline: "Privacy",
    description:
      "At ExactMail.io, we take your privacy seriously. Here's how we handle your information when you use our email finding services.",
    keyElements: [
      {
        section: "Information We Collect",
        icon: <FaSearch className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Personal Data", "Usage Data"],
        details: [
          "We collect information like your name, email address, and payment details when you create an account or make a purchase. For our email finding services, we process the information you provide about the people whose emails you want to find.",
          "We collect data about how you use our platform, including search history, features used, and time spent on our services. This helps us improve your experience.",
        ],
      },
      {
        section: "How We Use Your Information",
        icon: <FaBullhorn className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["To Provide Our Services", "Communication"],
        details: [
          "We use your information to deliver our email finding and verification services, process payments, and maintain your account.",
          "We may contact you about service updates, new features, or offers related to email discovery. You can opt out of marketing messages anytime.",
        ],
      },
      {
        section: "Data Sharing and Disclosure",
        icon: <FaProjectDiagram className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["With Service Partners", "When Required by Law"],
        details: [
          "We work with trusted partners who help us deliver our services, like payment processors and email verification systems. They only receive what they need to do their job.",
          "We may share information when required by law, to protect rights, or address security concerns.",
        ],
      },
      {
        section: "Data Security",
        icon: <MdOutlineSecurity className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Protection Measures", "Your User Responsibilities"],
        details: [
          "We use encryption, secure servers, and regular security reviews to protect your information and the email data you entrust to us.",
          "We recommend using strong passwords and enabling two-factor authentication to help keep your account secure.",
        ],
      },
      {
        section: "Your Rights and Choices",
        icon: <FaUserLock className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: [
          "Manage Your Access and Information",
          "Request Data Deletion",
        ],
        details: [
          "You can access and update your personal information through your account settings anytime.",
          "You can contact us to request deletion of your data, subject to any legal requirements to maintain certain records.",
        ],
      },
      {
        section: "Privacy Policy Updates",
        icon: <MdOutlinePrivacyTip className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Notification"],
        details: [
          "If we update this policy, we'll notify you via email or through our platform about changes taking effect.",
        ],
      },
    ],
  },

  terms: {
    title1: "Understanding Our",
    titleline: "Terms",
    pretitle2: "Our Terms of Service",
    pretitleline: "Review",
    description:
      "These Terms of Service explain how you can use ExactMails and outline the basic rules for using our website and services.",
    keyElements: [
      {
        section: "Intellectual Property",
        icon: <GoProjectRoadmap className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Ownership Rights", "Restrictions"],
        details: [
          "Clarification on content ownership and licensing.",
          "Specific limitations on copying, distributing, or modifying ExactMails' content and services.",
        ],
      },
      {
        section: "User Responsibilities",
        icon: <BiLogoBlogger className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Information Accuracy", "Account Security"],
        details: [
          "Users must provide accurate and current information when using our email discovery services.",
          "Users are responsible for maintaining the confidentiality of their login credentials and account security.",
        ],
      },
      {
        section: "Prohibited Activities",
        icon: <MdOutlineLocalActivity className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Misuse of Services", "Compliance Requirements"],
        details: [
          "Unauthorized access, data scraping, or interfering with ExactMails' operation is prohibited.",
          "Using our email discovery services for unlawful purposes or in violation of applicable regulations is not permitted.",
        ],
      },
      {
        section: "Terms Acceptance",
        icon: <BsFillTerminalFill className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Binding Agreement"],
        details: [
          "By using ExactMails, you acknowledge and agree to these Terms of Service.",
        ],
      },
      {
        section: "Limitation of Liability",
        icon: <LiaBity className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Service Disclaimers"],
        details: [
          "Clear explanation of ExactMails' liability scope regarding our email verification and discovery services.",
        ],
      },
      {
        section: "Account Termination",
        icon: (
          <MdOutlineIndeterminateCheckBox className="text-[#39C4DC] text-xl" />
        ),
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Suspension of Access"],
        details: ["Conditions under which accounts may be terminated."],
      },
      {
        section: "Governing Law",
        icon: <GoLaw className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Legal Jurisdiction"],
        details: [
          "The laws governing these Terms of Service and procedures for dispute resolution.",
        ],
      },
    ],
  },

  cookie: {
    title1: "How We Use",
    titleline: "Cookies",
    pretitle1: "Read Our",
    pretitle2: "Policy",
    pretitleline: "Cookie",
    description:
      "Our Cookie Policy explains how EveryMailFinder.com uses cookies and similar technologies to recognize you when you visit our website.",
    keyElements: [
      {
        section: "What Are Cookies?",
        icon: <FaCookieBite className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Definition", "Cookie Management"],
        details: [
          "Cookies are small text files that are stored on a user's computer or device when they visit a website. They are widely used to enhance the browsing experience by remembering user preferences, tracking user activity, and providing personalized content.",
          "Most web browsers allow users to manage their cookie settings. Users can choose to accept or reject cookies, delete existing cookies, or set their browser to block cookies from specific websites.",
        ],
      },
      {
        section: "Types of Cookies We Use",
        icon: <MdOutlineDiversity2 className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Essential Cookies", "Performance Cookies"],
        details: [
          "These cookies are absolutely necessary for the website to function properly. They enable core functionalities such as page navigation, access to secure areas, and form submission. Without these cookies, the website may not operate as intended, and you may not be able to access certain features or content.",
          "These cookies collect information about how visitors interact with our website. They help us understand which pages are most popular, how users navigate through the site, and if they encounter any errors. This data allows us to analyze and improve the website's performance, identify areas for enhancement, and optimize the user experience.",
        ],
      },
      {
        section: "Managing Cookies",
        icon: <SiManageiq className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["User Control", "Targeting/Advertising Cookies"],
        details: [
          "Users have the ability to manage or disable cookies through their browser settings. Typically, this can be found within the Privacy or Security section of the browser's settings menu.",
          "hese cookies are used to deliver relevant advertisements to users based on their browsing behavior and interests. They can also be used to track the performance of ad campaigns.",
        ],
      },
      {
        section: "Third-Party Cookies",
        icon: <FaProjectDiagram className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["External Services"],
        details: [
          "External services that utilize third-party cookies often collect information about user browsing habits, preferences, and demographics. This data can be used to deliver targeted advertising, personalize content, and measure website performance. While third-party cookies can provide valuable insights to website owners and advertisers, they also raise privacy concerns due to their ability to track users across different websites without their explicit consent.",
        ],
      },
      {
        section: "Privacy Concerns",
        icon: <VscLaw className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: [""],
        details: [
          "The use of third-party cookies has raised concerns among privacy advocates due to their potential for tracking user behavior across multiple websites without their knowledge or consent. This tracking can create detailed profiles of users' online activities, which can be used for targeted advertising or other purposes.",
        ],
      },
      {
        section: "Regulations and User Controls",
        icon: <AiFillControl className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: [""],
        details: [
          "In response to privacy concerns, several countries and regions have implemented regulations to restrict the use of third-party cookies. Additionally, web browsers offer users the ability to control or block third-party cookies through their settings.",
        ],
      },
    ],
  },

  gdpr: {
    title1: "Your Data",
    titleline: "Protection",
    title2: "Rights Under GDPR",
    pretitle1: "Learn More About Our",
    pretitle2: "Commitment",
    pretitleline: "GDPR",
    description:
      "As part of our commitment to data protection, we comply with the European Union's General Data Protection Regulation (GDPR).",
    keyElements: [
      {
        section: "Data Controller Information",
        icon: <AiFillControl className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: [
          "Company Details",
          "Right to Data Portability",
          "Right to Object",
        ],
        details: [
          "Name and contact information of the data controller.",
          "Transfer data to another organization.",
          "Object to data processing in certain circumstances.",
        ],
      },
      {
        section: "Lawful Basis for Processing",
        icon: <VscLaw className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Consent", "Contractual Necessity", "Right to Erasure"],
        details: [
          "When and how consent is obtained.",
          "Processing required to fulfill contracts.",
          "Request deletion of personal data.",
        ],
      },
      {
        section: "User Rights",
        icon: <TbAlignBoxRightStretch className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: [
          "Right to Access",
          "Right to Rectification",
          "Right to Restrict Processing",
        ],
        details: [
          "Users can request copies of their personal data.",
          "Correct inaccurate or incomplete data.",
          "Limit how data is used.",
        ],
      },
      {
        section: "Data Transfer Outside the EU",
        icon: <FaProjectDiagram className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Safeguards"],
        details: ["Measures taken when transferring data internationally."],
      },
      {
        section: "Data Breach Notification",
        icon: <IoNotifications className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Procedures"],
        details: ["How users will be notified of data breaches."],
      },
    ],
  },

  data: {
    title1: "Data",
    titleline: "Processing",
    title2: "Agreement",
    pretitle1: "Access Our Data Processing",
    pretitleline: "Agreement",
    description:
      "The Data Processing Agreement ensures that we adhere to all applicable data protection laws when handling personal data on behalf of our users.",
    keyElements: [
      {
        section: "Processing Details",
        icon: <TbListDetails className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["Purpose", "Duration"],
        details: [
          "Reasons for processing data.",
          "How long data will be processed and stored.",
        ],
      },
      {
        section: "Scope and Roles",
        icon: <PiMicroscopeFill className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Data Processor and Controller"],
        details: ["Definitions and responsibilities."],
      },
      {
        section: "Sub-Processors",
        icon: <MdOutlineSubtitles className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Third Parties"],
        details: ["List of sub-processors and services they provide."],
      },
      {
        section: "Security Measures",
        icon: <SiSpringsecurity className="text-[#64D1AE] text-xl" />,
        bgImage: card3Bg,
        color: "text-[#64D1AE]",
        bgcolor: "bg-[#EBFBF4]",
        border: "border-[#98E2C9]",
        heading: ["Technical and Organizational Measures"],
        details: ["Details on how data is protected."],
      },
      {
        section: "Audits and Inspections",
        icon: <LuInspect className="text-[#F88DA0] text-xl" />,
        bgImage: card2Bg,
        color: "text-[#F88DA0]",
        bgcolor: "bg-[#FDEBED]",
        border: "border-[#F9AFBB]",
        heading: ["User Rights"],
        details: ["DeAbility to audit compliance."],
      },
      {
        section: "International Transfers",
        icon: <FaMoneyBillTransfer className="text-[#39C4DC] text-xl" />,
        bgImage: card1Bg,
        color: "text-[#39C4DC]",
        bgcolor: "bg-[#EBFBFC]",
        border: "border-[#99E1ED]",
        heading: ["Compliance"],
        details: ["Adherence to data transfer regulations."],
      },
    ],
  },
};
